import React from "react"

/** Reactive functionality */
export namespace Reactive {
    /** A subscription on a `Subject` as an observer. */
    export class Subscription<T> {
        constructor(private subject: Subject<T>, private callback: (data: T) => void) {}

        public unsubscribe() {
            global.executions.addLine({className: "Subscription",functionName: "unsubscribe",hierarchy: ["/shared/utils/reactive.ts", "Reactive", "Subscription", "unsubscribe"],fileName: "/shared/utils/reactive.ts",childLine: 10,line: "            this.subject.unsubscribe(this)"});
            this.subject.unsubscribe(this)
        }
    }

    /** A topic or subject that can be subscribed to by observers */
    export class Subject<T> {
        private subscriptions: Subscription<T>[] = []

        public next(data: T) {
            global.executions.addLine({className: "Subject",functionName: "next",hierarchy: ["/shared/utils/reactive.ts", "Reactive", "Subject", "next"],fileName: "/shared/utils/reactive.ts",childLine: 19,line: "            this.subscriptions.forEach((subscription) => subscription['callback'](data))"});
            this.subscriptions.forEach((subscription) => subscription['callback'](data))
        }

        public subscribe(callback: (data: T) => void): Subscription<T> {
            global.executions.addLine({className: "Subject",functionName: "subscribe",hierarchy: ["/shared/utils/reactive.ts", "Reactive", "Subject", "subscribe"],fileName: "/shared/utils/reactive.ts",childLine: 23,line: "            const subscription = new Subscription(this, callback as any)"});
            const subscription = new Subscription(this, callback as any)
            global.executions.addLine({className: "Subject",functionName: "subscribe",hierarchy: ["/shared/utils/reactive.ts", "Reactive", "Subject", "subscribe"],fileName: "/shared/utils/reactive.ts",childLine: 24,line: "            this.subscriptions.push(subscription)"});
            this.subscriptions.push(subscription)
            global.executions.addLine({className: "Subject",functionName: "subscribe",hierarchy: ["/shared/utils/reactive.ts", "Reactive", "Subject", "subscribe"],fileName: "/shared/utils/reactive.ts",childLine: 25,line: "            return subscription as any"});
            return subscription as any
        }

        public unsubscribe(subscription: Subscription<T>) {
            global.executions.addLine({className: "Subject",functionName: "unsubscribe",hierarchy: ["/shared/utils/reactive.ts", "Reactive", "Subject", "unsubscribe"],fileName: "/shared/utils/reactive.ts",childLine: 29,line: "            this.subscriptions = this.subscriptions.filter((v) => v !== subscription)"});
            this.subscriptions = this.subscriptions.filter((v) => v !== subscription)
        }
    }

    /** A component with built-in reactive features */
    export class Component<P extends {} = {}, S extends {} = {}> extends React.Component<P, S> {
        protected subscriptions: Subscription<any>[] = []

        constructor(props: P) {
            global.executions.addLine({className: "Component",functionName: "[constructor]",hierarchy: ["/shared/utils/reactive.ts", "Reactive", "Component", "[constructor]"],fileName: "/shared/utils/reactive.ts",childLine: 38,line: "            super(props)"});
            super(props)
        }

        public componentWillUnmount = () => {
            // Unsubscribes
            global.executions.addLine({className: "Component",functionName: "componentWillUnmount",hierarchy: ["/shared/utils/reactive.ts", "Reactive", "Component", "componentWillUnmount"],fileName: "/shared/utils/reactive.ts",childLine: 43,line: "            this.subscriptions.forEach(s => s.unsubscribe())"});
            this.subscriptions.forEach(s => s.unsubscribe())
        }
    }
}